import { handleToggleViewTransitions } from './galleryGridTransitions';

export const galleryAddToggleViewButtonsListeners = () => {
  const toggleViewButtons = document.querySelectorAll('[data-toggle-view]');
  if (toggleViewButtons.length > 0) {
    toggleViewButtons.forEach((toggleViewButton) => {
      toggleViewButton.addEventListener('click', handleToggleViewTransitions);
    });
  }

  return () => {
    toggleViewButtons.forEach((toggleViewButton) => {
      toggleViewButton.removeEventListener('click', handleToggleViewTransitions);
    });
  };
};
